import { render, staticRenderFns } from "./aptitude.vue?vue&type=template&id=4c7ad960&"
import script from "./aptitude.vue?vue&type=script&lang=js&"
export * from "./aptitude.vue?vue&type=script&lang=js&"
import style0 from "./aptitude.vue?vue&type=style&index=0&id=4c7ad960&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports